import { isEmpty, map, pickBy } from 'lodash-es';
import Image from 'next/image';
import PropTypes from 'prop-types';
import React from 'react';
import { LikeTypeDetails } from '../../constants/likeDetails.constant';

const getReactionTypes = (reactions) => {
  return map(reactions, (count, type) => ({
    type: type,
    icon: LikeTypeDetails.find((l) => l.type === type)?.icon,
    count: count,
  })).filter((r) => !!r.icon);
};

function Reactions(props) {
  const { reactions, onClick, children } = props;
  const reactionsToDisplay = pickBy(reactions, (count) => count > 0);

  const handleClick = () => {
    if (onClick) {
      onClick();
    }
  };

  if (isEmpty(reactionsToDisplay)) {
    return null;
  }

  return (
    <div
      className="flex items-center gap-2.5"
      role="button"
      onClick={handleClick}>
      <div className="flex -space-x-[6px]">
        {getReactionTypes(reactions).map((reaction) => (
          <Image
            key={reaction.type}
            src={reaction.icon}
            alt={reaction.type}
            width="20"
            height="18"
            className={`relative z-9 inline rounded-full bg-white object-cover p-0.5`}
          />
        ))}
      </div>
      {children}
    </div>
  );
}

Reactions.propTypes = {
  reactions: PropTypes.objectOf(PropTypes.number),
  onClick: PropTypes.func,
  children: PropTypes.node,
};

export default Reactions;
